import { Select } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { DefaultOptionType } from 'antd/es/select';

type EmployeeSelectorProps = {
  isRequired?: boolean;
  label?: React.ReactNode;
  loading?: boolean;
  multiple?: boolean;
  options: Array<DefaultOptionType>;
  disabled?: boolean;
};

export default function EmployeeSelectorComponent(
  props: EmployeeSelectorProps
) {
  const { multiple, options, isRequired, loading, disabled } = props;

  return (
    <FormItem
      name={multiple ? 'employeeIds' : 'employeeId'}
      label={props.label ? props.label : '員工'}
      rules={[{ required: isRequired, message: '請選擇員工' }]}
    >
      <Select
        mode={multiple ? 'multiple' : undefined}
        disabled={disabled}
        loading={loading}
        optionFilterProp="label"
        options={options}
        placeholder="請選擇員工"
        showSearch
      />
    </FormItem>
  );
}
